import { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./sidebar";
import Navbar from "./navbar";
import "./layout.css";

export default function Layout() {
  const [collapsed, setCollapsed] = useState(false);
  // Off-canvas drawer state — only relevant at phone widths (<=640px),
  // where sidebar.jsx/layout.css switch the sidebar into drawer mode.
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="layout">
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />

      <div className="main-section">
        <Navbar onMenuClick={() => setMobileOpen(true)} />

        {/*  REQUIRED */}
        <div className="content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
